import { customerPersonaGroupSchema } from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCustomerPersonas = {
  name: "getCustomerPersonas" as const,
  input: z.object({ customerId: zExt.objectId() }),
  output: z.object({ personaGroups: z.array(customerPersonaGroupSchema) }),
};
